import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Assuming you want the same styling

const UserRoleDetails = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [roleDetails, setRoleDetails] = useState([
    { role: "Admin", status: "Active", id: 1 },
    { role: "System Admin", status: "Active", id: 2 },
    { role: "Super Admin", status: "Active", id: 3 },
    { role: "Client Web", status: "Inactive", id: 4 },
    { role: "Void Mobile", status: "Inactive", id: 5 },
    { role: "POS User", status: "Active", id: 6 },
  ]);

  const [formData, setFormData] = useState({
    role: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [roleDetails]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedRole) {
      setRoleDetails(
        roleDetails.map((role) =>
          role.id === selectedRole.id ? { ...formData, id: role.id } : role
        )
      );
    } else {
      setRoleDetails([
        ...roleDetails,
        {
          ...formData,
          id: roleDetails.length ? roleDetails[roleDetails.length - 1].id + 1 : 1,
        },
      ]);
    }
    setShowForm(false);
    setFormData({ role: "", status: "Active" });
    setSelectedRole(null);
  };

  const handleEdit = (role) => {
    setSelectedRole(role);
    setFormData({
      role: role.role,
      status: role.status,
    });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedRole(null);
    setFormData({ role: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="role-list d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left-side Form Panel */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "320px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedRole ? "Edit Role" : "Add Role"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Role:</label>
              <input
                type="text"
                name="role"
                value={formData.role}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Table Section */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>User Role Details</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Role
            </button>
          </div>
          <div className="card-body">
            <table
              ref={tableRef}
              className="table table-bordered display"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {roleDetails.map((role) => (
                  <tr key={role.id}>
                    <td>{role.role}</td>
                    <td>
                      <span
                        className={`badge ${
                          role.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {role.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(role)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRoleDetails;
